//------ 草图几何容差配置 开始------
/**
 * 草图几何容差配置。
 *
 * 设计说明：
 * 1. 草图对象、绘制器和闭合集合必须从这里读取统一容差；
 * 2. 线性尺寸容差取 `1e-12`，避免毫米级甚至亚毫米级草图被旧的 `1e-8` 过滤；
 * 3. 角度容差保持语义型配置，避免圆弧端点拖拽出现 0 或 2π 的退化扫掠；
 * 4. 配置只保存纯数值，不依赖 Three.js 或运行时对象。
 */
export const SKETCH_GEOMETRY_TOLERANCE_CONFIG = {
    /** 绘制阶段回吸闭合的屏幕/世界距离容差。 */
    drawingClosureSnap: 1e-2,
    /** 自闭合曲线首尾点坐标容差。 */
    closedCurvePosition: 1e-6,
    /** 闭合集合至少需要的边数量。 */
    minimumClosedSourceCount: 2,
    /** 闭合集合端点坐标兜底容差。 */
    collectionClosurePosition: 1e-9,
    /** 曲线半径、半轴长度、弦长等线性尺寸的最小有效值。 */
    curveLinearLength: 1e-12,
    /** 曲线线性尺寸平方的最小有效值。 */
    curveLinearLengthSquared: 1e-24,
    /** 完整圆弧或完整椭圆扫掠角判断容差。 */
    fullSweepAngle: 1e-9,
    /** 部分圆弧或部分椭圆最小扫掠角。 */
    partialSweepAngle: 1e-9,
    /** 圆弧端点拖拽最小扫掠角。 */
    arcEndpointDragMinimumSweep: 1e-6,
    /** 圆弧端点拖拽距离分母兜底值。 */
    arcEndpointDragDenominator: 1e-12,
    /** 圆弧端点拖拽垂直方向退化判定。 */
    arcEndpointPerpendicularLengthSquared: 1e-24,
    /** 绘制线方向向量最小有效长度。 */
    lineDirectionLength: 1e-6,
    /** 线对象方向向量最小有效长度平方。 */
    lineDirectionLengthSquared: 1e-12,
    /** 三角函数分母最小有效值。 */
    trigonometricDenominator: 1e-8,
    /** 矩形投影退化判断容差。 */
    rectangleProjectionPosition: 1e-6,
    /** 抛物线参数区间最小有效跨度。 */
    parabolaMinimumParameterSpan: 1e-6,
    /** 抛物线左右距离对称判断容差。 */
    parabolaDistanceSymmetry: 1e-8,
    /** 槽口半径最小有效值。 */
    slotMinimumRadius: 1e-6,
    /** 槽口轴向向量最小有效长度平方。 */
    slotAxisLengthSquared: 1e-8,
    /** 槽口最小宽度。 */
    slotMinimumWidth: 1e-4,
    /** 样条权重最小有效值。 */
    splineMinimumWeight: 1e-6,
    /** 样条有理权重偏差判断容差。 */
    splineRationalWeightDelta: 1e-6,
    /** Trim 真实参数曲线交点的世界空间距离容差。 */
    trimIntersectionDistance: 1e-6,
    /** Trim 真实参数曲线求根和去重的参数容差。 */
    trimIntersectionParameter: 1e-10,
    /** Trim 穿越与相切分类使用的归一化角度容差。 */
    trimIntersectionAngular: 1e-8,
} as const;
//------ 草图几何容差配置 结束------
